module.exports = __webpack_public_path__ + "_assets/img/game.dffcccc4.svg";